import { Component, EventEmitter, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Jobsite } from '../../models'

export interface CSVImportDialogInput {
  jobsiteId: string | null | undefined
  currentJobsite: Jobsite | null
  isSBT: boolean
}

@Component({
  selector: 'soillib-csv-import-dialog',
  templateUrl: 'csv-import-dialog.html',
})
export class CSVImportDialog {
  jobsiteId: string | null | undefined
  isSBT: boolean

  onFinishAgsImport = new EventEmitter<Jobsite>()

  constructor(
    public dialogRef: MatDialogRef<CSVImportDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CSVImportDialogInput,
  ) {
    this.jobsiteId = data.jobsiteId
    this.isSBT = data.isSBT
  }

  finishAgsImport(newJobsite: Jobsite) {
    this.onFinishAgsImport.emit(newJobsite)
    this.close()
  }

  close(): void {
    this.dialogRef.close()
  }
}
